import FinanceXTransactions from './FinanceXTransactions.container';

export default FinanceXTransactions;
